import { Grid } from '@simplywallst/ui-core';
import { Bones } from '@simplywallst/ui-core';

const ArticleSkeleton = () => (
  <Grid gap="80px">
    <Grid templateColumns="1fr" templateColumnsLg="1fr 1fr" gapMd="20px">
      <Grid>
        <Bones maxWidth="100%" minHeight="315px" backgroundColor="black" />
      </Grid>
      <Grid alignContent="center" gap="20px">
        <Bones minHeight="60px" backgroundColor="black" />
        <Bones minHeight="100px" backgroundColor="black" />
      </Grid>
    </Grid>

    {/* Article list */}
    <Grid
      templateColumns="1fr"
      templateColumnsLg="1fr 1fr 1fr 1fr"
      gap="20px"
      rowGapMd="80px"
      rowGapSm="40px"
    >
      {/* First row */}
      <Grid>
        <Bones maxWidth="100%" minHeight="24px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="100px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="16px" backgroundColor="black" />
      </Grid>
      <Grid>
        <Bones maxWidth="100%" minHeight="24px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="100px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="16px" backgroundColor="black" />
      </Grid>
      <Grid>
        <Bones maxWidth="100%" minHeight="24px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="100px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="16px" backgroundColor="black" />
      </Grid>
      <Grid>
        <Bones maxWidth="100%" minHeight="24px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="100px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="16px" backgroundColor="black" />
      </Grid>

      {/* Second row  */}
      <Grid>
        <Bones maxWidth="100%" minHeight="24px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="100px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="16px" backgroundColor="black" />
      </Grid>
      <Grid>
        <Bones maxWidth="100%" minHeight="24px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="100px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="16px" backgroundColor="black" />
      </Grid>
      <Grid>
        <Bones maxWidth="100%" minHeight="24px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="100px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="16px" backgroundColor="black" />
      </Grid>
      <Grid>
        <Bones maxWidth="100%" minHeight="24px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="100px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="16px" backgroundColor="black" />
      </Grid>

      {/* Third row  */}
      <Grid>
        <Bones maxWidth="100%" minHeight="24px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="100px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="16px" backgroundColor="black" />
      </Grid>
      <Grid>
        <Bones maxWidth="100%" minHeight="24px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="100px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="16px" backgroundColor="black" />
      </Grid>
      <Grid>
        <Bones maxWidth="100%" minHeight="24px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="100px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="16px" backgroundColor="black" />
      </Grid>
      <Grid>
        <Bones maxWidth="100%" minHeight="24px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="100px" backgroundColor="black" />
        <Bones maxWidth="100%" minHeight="16px" backgroundColor="black" />
      </Grid>
    </Grid>
  </Grid>
);

export default ArticleSkeleton;
